<template>
  <exercise-logic
    exCollection="empathyExCollection"
    @ready="onReady"
    @error="onError"
    @saved="onSaved"
    @savedNext="onSavedNext"
    @loadedEx="onLoadedEx"
    @loadedRefs="onLoadedRefs"
    :doc="doc"
    :shared="false"
  >
    <template slot-scope="{ saveExercise }">
      <v-row>
        <v-col cols="4" class="mb-4">
          <h2 class="headline" v-text="$t('exercise_empathy.step1.title')"></h2>
        </v-col>
        <v-col cols="8" lg="6" class="mb-4">
          <p
            v-for="(item, index) in $t('exercise_empathy.step1.description')"
            :key="index"
            v-text="item"
          />
        </v-col>
      </v-row>
      <v-row v-if="doc">
        <v-col cols="6">
          <v-card height="100%"
            ><v-card-text>
              <unit-items-icon
                v-model="doc.think"
                :limit="10"
                name="stop"
                title="THINK"
                color="amber"
                size="contain"
                svg="Thought.svg"
              >
              </unit-items-icon> </v-card-text
          ></v-card>
        </v-col>
        <v-col cols="6">
          <v-card height="100%"
            ><v-card-text>
              <unit-items-icon
                v-model="doc.do"
                :limit="10"
                name="do"
                title="DO"
                size="contain"
                color="amber"
                svg="Do.svg"
              >
              </unit-items-icon> </v-card-text
          ></v-card>
        </v-col>
        <v-col cols="6">
          <v-card height="100%"
            ><v-card-text>
              <unit-items-icon
                v-model="doc.feel"
                :limit="10"
                name="feel"
                title="FEEL"
                size="contain"
                color="amber"
                svg="Heart.svg"
              >
              </unit-items-icon> </v-card-text
          ></v-card>
        </v-col>
        <v-col cols="6">
          <v-card height="100%"
            ><v-card-text>
              <unit-items-icon
                v-model="doc.say"
                :limit="10"
                name="say"
                title="SAY"
                color="amber"
                size="contain"
                svg="Speech.svg"
              >
              </unit-items-icon> </v-card-text
          ></v-card>
        </v-col>
      </v-row>
      <bottom-navigation
        :save="true"
        :next="false"
        :prev="false"
        :gridView="false"
        :gridToggle="false"
        @save="saveExercise"
        @prev="prevStep"
        @next="saveExercise(false)"
      >
      </bottom-navigation>
 <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>


         <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>

          <v-btn
            color="amber accent-1"
            text
            :to="`/users/project/${$route.params.id}`"
          >
            Back to Project
          </v-btn>
          <v-btn color="amber accent-1" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
      
    </v-dialog>
    </template>
  </exercise-logic>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";
import { UnitItemsIcon } from "@/components/units";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserTraffic",
  data() {
    return {
      e1: 1,
      doc: {
        think: [],
        do: [],
        feel: [],
        say: [],
      },
      tabs: [{ title: "Empathy Maps", count: 1 }],
      userSelected: null,
      debug: false,
      dialog: false
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    UnitItemsIcon,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },

  mounted() {},
  methods: {
    nextStep() {
      this.e1++;
      // this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      // this.saveExercise(false);
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved");
       this.dialog = true;
    },
    onLoadedRefs(refs) {
      console.log("loaded", refs);
    },
    onLoadedEx(ex) {
      this.doc = ex.doc;
      this.exercise = ex;
    },
    onSavedNext() {
      this.nextStep();
    },
     closeDialog() {
      this.dialog = false;
    }
  },
};
</script>
